export const getEasing = (props) => props.theme.easing;
//# sourceMappingURL=getEasing.mjs.mjs.map